import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

export interface ConfirmModalData {
  message: string
  title?: string
  /** Onay butonu tehlike stili (sil/kopar gibi) */
  danger?: boolean
  confirmLabel?: string
  onConfirm: () => void
}

/**
 * Temalı, ortalanmış onay modalı — native confirm() yerine kullanılır.
 * CLAUDE.md kuralı: overlay'e tıklayarak kapatma YOK; yalnızca buton ile kapanır.
 */
export function ConfirmModal({ data, onClose }: { data: ConfirmModalData | null; onClose: () => void }) {
  const { t } = useTranslation('common')
  if (!data) return null

  const iconStyle = data.danger ? 'bg-destructive/15 text-destructive' : 'bg-warning/15 text-warning'

  return createPortal(
    <div className="modal-overlay">
      <div className="modal-box max-w-md">
        <div className="p-6 flex flex-col items-center text-center gap-4">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl font-bold ${iconStyle}`}>
            ?
          </div>
          {data.title && <h2 className="text-base font-semibold text-foreground">{data.title}</h2>}
          <p className="text-sm text-muted-foreground whitespace-pre-line">{data.message}</p>
          <div className="flex gap-2 mt-2 w-full justify-center">
            <button onClick={onClose} className="btn-secondary text-sm min-w-24">
              {t('confirmModal.cancel', { defaultValue: 'İptal' })}
            </button>
            <button
              onClick={() => { data.onConfirm(); onClose() }}
              className={`${data.danger ? 'btn-danger' : 'btn-primary'} text-sm min-w-24`}
            >
              {data.confirmLabel ?? t('confirmModal.confirm', { defaultValue: 'Onayla' })}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default ConfirmModal
